import { isEmpty } from 'lodash'
import compact from 'lodash/compact'

import { applyFilters } from 'modules/core/lib/filters'
import type FiltersForm from 'modules/core/lib/forms/Filters'
import { matchText } from 'modules/core/lib/stringUtils'
import users from 'modules/core/store/collections/users'

import type Employee from 'modules/employees/store/models/Employee'
import goalsConfig from 'modules/goals/store/collections/goalsconfig'
import type GoalConfig from 'modules/goals/store/models/GoalConfig'

export const filterBySearch = (search: string): GoalConfig[] =>
  goalsConfig.models.filter((goalConfig: GoalConfig) => {
    if (isEmpty(search)) return goalsConfig.models

    return matchText(search, goalConfig.attributes.name)
  })

export const filterByStatus = (filteredBySearch: GoalConfig[], status: string): GoalConfig[] =>
  filteredBySearch.filter((goalConfig: GoalConfig) => {
    if (!status.length) return filteredBySearch

    return goalConfig.attributes.status === status
  })

export const filterByEmployee = async (
  filteredByStatus: GoalConfig[],
  employeesFiltersForm: FiltersForm,
  filterBy: string
): Promise<GoalConfig[]> => {
  if (!filterBy.length) return filteredByStatus

  const ownersByGoalConfigId = Object.fromEntries(
    await Promise.all(
      filteredByStatus.map(async (goalConfig: GoalConfig) => {
        const owners: Employee[] = compact(
          goalConfig.attributes.owner_ids.map((id: number) => users.get(id)?.employee)
        )

        const filteredEmployees = await applyFilters(employeesFiltersForm, owners)

        return [goalConfig.id, filteredEmployees]
      })
    )
  )

  return filteredByStatus.filter(
    (goalConfig: GoalConfig) => !!ownersByGoalConfigId[goalConfig.id].length
  )
}
